import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';
import { ModalBankComponent } from '@components/managements/banks/modal-banks/modal-bank.component';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { CampusService } from '@services/campus.service';
import { RutValidator } from 'app/validators/iatuch.validators';
import { EntityService } from '@services/entity.service';

@Component({
    selector: 'app-edit-office',
    standalone: true,
    imports: [ CoreModule],
    providers: [EntityService],
    templateUrl: './edit-entity.component.html',
    styleUrls: ['./edit-entity.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditEntityComponent implements OnInit {

    @Input() office: any
    @Input() permissions: any
    @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>()

    private _entityService = inject(EntityService)
    private fb = inject(FormBuilder)
    private destroyRef = inject(DestroyRef)

    public officeForm: any


    ngOnInit(): void {
        this.officeForm = this.fb.group({
            _id: [null],
            name: [null, Validators.required], 
            // acronym: [null, Validators.required],
            rut: [null, [Validators.required, Validators.pattern('^[0-9,$]*$')]],
            dv: [null],
            enabled: [true]
        })
        if (this.office) {
            this.setDataOffice()
        }
    }

    setDataOffice() {
        this.officeForm.patchValue(this.office)
    }

    cancel() {
        this.refresh.emit(false)
        this.officeForm.reset()
    }

    submit() {
        // if (this.officeForm.valid) {
            if (this.office) {
                this._entityService.updateEntity(this.officeForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
                    this.refresh.emit(true)
                })
            } else {
                this._entityService.updateEntity(this.officeForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
                    this.refresh.emit(true)
                })
            }
        // }else{
        //     this.officeForm.markAsDirty();
        // }

    }

    setDV(){
        const dv = RutValidator.setDigitVerificator(this.officeForm.value.rut.toString())
        this.officeForm.patchValue({dv: dv})
    }

}
